import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37ad3217"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "industry-list" }
const _hoisted_2 = { class: "industry-list-wrap" }
const _hoisted_3 = { class: "industry-list-center" }
const _hoisted_4 = { class: "industry-list-content" }
const _hoisted_5 = { class: "industry-list-ct" }
const _hoisted_6 = { class: "industry-list-box" }
const _hoisted_7 = { class: "industry-list-box-line" }
const _hoisted_8 = { class: "industry-list-box-line-title" }
const _hoisted_9 = { class: "industry-list-box-line-rt" }
const _hoisted_10 = { class: "industry-list-box-list" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "industry-list-box-item-bt" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "industry-list-box-item-zz" }, null, -1))
const _hoisted_14 = { class: "industry-list-box-item-content" }
const _hoisted_15 = { class: "industry-list-box-item-title" }
const _hoisted_16 = { class: "industry-list-box-item-time" }
const _hoisted_17 = { class: "industry-list-box-item-address" }
const _hoisted_18 = {
  key: 0,
  class: "industry-list-box-item-status status3"
}
const _hoisted_19 = {
  key: 1,
  class: "industry-list-box-item-status status4"
}
const _hoisted_20 = {
  key: 2,
  class: "industry-list-box-item-status status5"
}
const _hoisted_21 = {
  key: 3,
  class: "industry-list-box-item-status status6"
}

import Bottom from '../components/bottom.vue'
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
const loading = ref(true);
var id = router.currentRoute.value.params.id;

const tabs = ref([
  {
    sort: 1,
    id: '563e20aa52ee4cc5ad1dbbf9834dd82e',
    name: '社区美居俱乐部年会'
  },
  {
    sort: 2,
    id: '2cb6963de0a14ccf92e348eb38a3c06b',
    name: '家居行业论坛'
  },
  {
    sort: 3,
    id: 'd68f9f6b58064950b05a54265181d035',
    name: '专题私董会'
  },
  {
    sort: 4,
    id: 'd3a895f9db1845ab889cfd4c19a1dbc9',
    name: '企业参访'
  },
  {
    sort: 5,
    id: 'aa43a089d1024011afea6b4237547c91',
    name: '名企游学'
  },
  {
    sort: 6,
    id: 'd9db983b61364fac9be50b2c0d970313',
    name: '友商活动'
  }
])

const tab = tabs.value.find(tab => tab.id == id);
var tabIndex = 0;
var pageTitle = "社区美居俱乐部年会"
if (id) {
  //const tab = tabs.value.find(tab => tab.id == id);
  if (tab) {
    pageTitle = tab.name;
    tabIndex = tab.sort - 1;
  }
}

const bindData = reactive({
  tabIndex: tabIndex,
  tab: tab,
  pageTitle: pageTitle,
  industryPageParams: {
    curPage: 1,
    pageSize: 6,
    filtrate: {
      type: 5,
      activityTagId: id,
      keyword: "",
    },
  },
  industryPageResult: {
    status: 2000,
    msg: "成功",
    result: [],
    totalCount: 0,
  },
});

const tabHandleClick = (tab: any, event: Event) => {
  bindData.tabIndex = Number(tab.index);
  const tabCUrr = tabs.value[bindData.tabIndex];
  bindData.pageTitle = tabCUrr.name;
  bindData.industryPageParams.filtrate.activityTagId = tabs.value[bindData.tabIndex].id;
  bindData.industryPageParams.curPage = 1;
  searchEvent();
};

const handleSizeChangeEvent = (value: any) => {
  bindData.industryPageParams.pageSize = value;
  bindData.industryPageParams.curPage = 1;
  searchEvent();
};

const handleCurrentChangeEvent = (value: any) => {
  bindData.industryPageParams.curPage = value;
  searchEvent();
};

const searchEvent = () => {
  store
    .dispatch("frontIndustryModule/pageActivityList", bindData.industryPageParams)
    .then(
      (data) => {
        //成功
        bindData.industryPageResult = data;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

searchEvent();



const handleToPage = (id: string) => {
  router.push("/frontDesk/industryIndex/industryDetail/" + id);
};

const handleToIndex = (id: string) => {
  router.push({ path: "/frontDesk/industryIndex", query: { id: id } });
}


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_arrow_right = _resolveComponent("arrow-right")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_tabs, {
          modelValue: _unref(bindData).pageTitle,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).pageTitle) = $event)),
          class: "demo-tabs",
          onTabClick: tabHandleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: tabs.value[0].name,
              name: tabs.value[0].name
            }, null, 8, ["label", "name"]),
            _createVNode(_component_el_tab_pane, {
              label: tabs.value[1].name,
              name: tabs.value[1].name
            }, null, 8, ["label", "name"]),
            _createVNode(_component_el_tab_pane, {
              label: tabs.value[2].name,
              name: tabs.value[2].name
            }, null, 8, ["label", "name"]),
            _createVNode(_component_el_tab_pane, {
              label: tabs.value[3].name,
              name: tabs.value[3].name
            }, null, 8, ["label", "name"]),
            _createVNode(_component_el_tab_pane, {
              label: tabs.value[4].name,
              name: tabs.value[4].name
            }, null, 8, ["label", "name"]),
            _createVNode(_component_el_tab_pane, {
              label: tabs.value[5].name,
              name: tabs.value[5].name
            }, null, 8, ["label", "name"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_image, {
          src: require('@/assets/fd/industry/pig1.jpg')
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(bindData).pageTitle), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", {
                  class: "btn btn-info",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleToIndex(_unref(bindData).tab.id)))
                }, "返回最新"),
                _createVNode(_component_el_icon, {
                  class: "el-icon--right",
                  style: {"color":"#ffffff"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_arrow_right)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).industryPageResult.result, (activity, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "industry-list-box-item",
                  key: activity.id,
                  onClick: ($event: any) => (handleToPage(activity.id))
                }, [
                  _createVNode(_component_el_image, {
                    class: "industry-list-box-item-bg",
                    src: activity.thumbnailUrl
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(activity.name), 1),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(activity.startTimeString) + " ~ " + _toDisplayString(activity.endTimeDateString), 1),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(activity.province) + "." + _toDisplayString(activity.city) + "." + _toDisplayString(activity.area) + " " + _toDisplayString(activity.address), 1)
                    ])
                  ]),
                  (activity.status == 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(activity.statusName), 1))
                    : (activity.status == 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(activity.statusName), 1))
                      : (activity.status == 5)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(activity.statusName), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(activity.statusName), 1))
                ], 8, _hoisted_11))
              }), 128))
            ]),
            (_unref(bindData).industryPageResult.totalCount > 6)
              ? (_openBlock(), _createBlock(_component_el_container, {
                  key: 0,
                  class: "account-page_toolbar"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_pagination, {
                      currentPage: _unref(bindData).industryPageParams.curPage,
                      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).industryPageParams.curPage) = $event)),
                      "page-size": _unref(bindData).industryPageParams.pageSize,
                      "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).industryPageParams.pageSize) = $event)),
                      "page-sizes": [6, 12, 48, 100],
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _unref(bindData).industryPageResult.totalCount,
                      "onUpdate:total": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).industryPageResult.totalCount) = $event)),
                      onSizeChange: handleSizeChangeEvent,
                      onCurrentChange: handleCurrentChangeEvent
                    }, null, 8, ["currentPage", "page-size", "total"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(Bottom)
  ]))
}
}

})